export const getErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof Error ? error.message : fallback;

export const getPrefixedErrorMessage = (prefix: string, error: unknown): string => {
  const message = error instanceof Error ? error.message : null;
  return message ? `${prefix}: ${message}` : `${prefix}.`;
};
